/** Complete phone identities shared by Home and backend attribution. */

/**
 * Legacy unqualified Malka/Maple numbers use the existing NANP default.
 * Apply a different selected dial country to typed input before comparing it.
 * Never extract identities from prose, handles, extensions or partial input.
 * Accept the parser so browsers can retain the library's tree-shakable import.
 * @param {Function} parsePhoneNumberFromString
 * @returns {(value: unknown) => string} Full identity, or empty when uncertain.
 */
function createPhoneMatchKey(parsePhoneNumberFromString) {
    return function phoneMatchKey(value) {
        if (typeof value !== 'string') return '';
        const input = value.trim();
        if (!/^\+?[0-9\s().-]+$/.test(input)) return '';
        const compact = input.replace(/[\s().-]/g, '');
        const international = compact.startsWith('00') ? `+${compact.slice(2)}` : compact;
        const parsed = parsePhoneNumberFromString(international, { defaultCountry: 'US', extract: false });

        return parsed?.isPossible() && !parsed.ext ? parsed.number : '';
    };
}

module.exports = { createPhoneMatchKey };
